'use client';

import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

export default function BillingInfoTextInput({
    label,
    name,
    placeholder,
    recurlyId,
    isEditable,
}: {
    label: string;
    name: string;
    placeholder: string;
    recurlyId?: string;
    isEditable?: boolean;
}): JSX.Element {
    return (
        <div key={name} className="flex flex-row justify-between items-center py-4 border-b-1 border-gray-300">
            <label htmlFor={name} className="w-full">
                {label}
            </label>
            {isEditable ? (
                <input
                    className={twMerge(
                        'w-full p-2 rounded-sm border border-solid border-white focus:border-blue-500',
                        isEditable && 'border-gray-300 focus:outline-none focus:ring-blue-500',
                        !isEditable && 'placeholder-gray-800 font-bold',
                    )}
                    id={name}
                    name={name}
                    placeholder={placeholder}
                    data-recurly={recurlyId}
                    type="text"
                    initial-value={placeholder}
                />
            ) : (
                <span className="w-full py-2 text-gray-800 font-bold">{placeholder}</span>
            )}
        </div>
    );
}
